import React from 'react'
import Chart from './Chart'

function App() {
  return (
    <div style={{ width: '100%', height: 600 }}>
      <Chart
        title='Einwanderungsland Schweiz'
        description='Anzahl Ausländer in der Schweiz nach Herkunftsland, 1850–2018'
        source='Grafik: amo · Quelle: BFS'
      />
    </div>
  )
}

export default App
